/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_DicInputs */

const cs_settings_office_dic = /** @type {(inputs: Settings_Office_DicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIČ`)
};

const en_settings_office_dic = /** @type {(inputs: Settings_Office_DicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIČ`)
};

/**
* | output |
* | --- |
* | "DIČ" |
*
* @param {Settings_Office_DicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_dic = /** @type {((inputs?: Settings_Office_DicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_DicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_dic(inputs)
	return cs_settings_office_dic(inputs)
});